import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-bounce-loader',
  standalone: false,
  templateUrl: './bounce-loader.component.html',
  styleUrl: './bounce-loader.component.scss'
})
export class BounceLoaderComponent {
 @Input() message: string = 'Loading.. Please Wait..';

}
